export default __webpack_public_path__ + "static/media/My-Img-5.45f7f6a1.jpg";